import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// Modules
import emails from './modules/emails';
import foundations from './modules/foundations';
import marathons from './modules/marathons';
import points from './modules/points';
import promocodes from './modules/promocodes';
import settings from './modules/settings';
import starts from './modules/starts';
import stats from './modules/stats';
import user from './modules/user';
import users from './modules/users';
import challenges from './modules/challenges';
import tax from './modules/tax';
import slides from './modules/slides';
import promos from './modules/promos';

Vue.use(Vuex);

const debug = false;// process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  modules: {
    emails,
    foundations,
    marathons,
    points,
    promocodes,
    settings,
    starts,
    stats,
    user,
    users,
    challenges,
    tax,
    slides,
    promos,
  },
  strict: debug,
});
